import projection from '../generated/pwd5m2f1.json';
import { AcceptanceManifest } from '../types';

export const pwd5m2f1AcceptanceManifest = projection as AcceptanceManifest;
